import React from 'react';
import { Button } from './ui/Button';
import { Moon, Star } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative overflow-hidden bg-slate-900 pt-16 pb-20 lg:pt-24 lg:pb-28" data-id="element-93">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none" data-id="element-94">
        <div className="absolute top-20 right-0 w-72 h-72 bg-indigo-500/10 rounded-full blur-3xl" data-id="element-95" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl" data-id="element-96" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-97">
        <div className="max-w-4xl mx-auto text-center" data-id="element-98">
          <div className="inline-flex items-center space-x-2 bg-slate-800/50 rounded-full px-4 py-1.5 mb-8 border border-slate-700/50 backdrop-blur-sm" data-id="element-99">
            <Moon className="w-4 h-4 text-amber-400" data-id="element-100" />
            <span className="text-sm font-medium text-slate-300" data-id="element-101">
              Protocolo Noche Tranquila 65+
            </span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight mb-6" data-id="element-102">
            Si se despierta a las 3AM… <br className="hidden sm:block" data-id="element-103" />
            <span className="text-amber-400" data-id="element-104">ya no improvises</span>
          </h1>

          <p className="text-xl sm:text-2xl text-slate-300 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-105">
            El plan de 14 noches para dormir sin pastillas. Tu mamá/papá no
            necesita fuerza de voluntad. Necesita un sistema.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-106">
            <Button size="lg" onClick={scrollToPricing} className="w-full sm:w-auto font-bold" data-id="element-107">
              Obtener Protocolo — $6.39
            </Button>
            <p className="text-sm text-slate-400 mt-2 sm:mt-0 flex items-center" data-id="element-108">
              <Star className="w-4 h-4 text-amber-400 mr-1 fill-amber-400" data-id="element-109" />
              Garantía de satisfacción
            </p>
          </div>
        </div>

        <div className="relative max-w-4xl mx-auto mt-8 rounded-2xl overflow-hidden shadow-2xl shadow-black/50 border border-slate-800" data-id="element-110">
          <img src="https://cdn.magicpatterns.com/uploads/a3w8192NHbF4fMqzUfKyXt/heylloyd-image-1770947182596.png" alt="Mujer mayor leyendo el protocolo en una tablet en la cama" className="w-full h-auto object-cover" data-id="element-111" />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent opacity-60" data-id="element-112" />
        </div>
      </div>
    </section>;
}